<template>
  <FormGroup>
    <h5 class="name">ช่องทางถ่ายทอดสด</h5>
    <div class="form-check" @click.stop="changeOptionValue('tv')">
      <input type="checkbox"
        class="form-check-input"
        :checked="broadcastingChannels.tv"
        @input="$emit('update:broadcastingChannels', { ...broadcastingChannels, tv: Boolean($event.target.checked) })"
        :disabled="disabled">
      <label class="form-check-label">
        TV
      </label>
    </div>
    <div class="form-check" @click.stop="changeOptionValue('web')">
      <input type="checkbox"
        class="form-check-input"
        :checked="broadcastingChannels.web"
        @input="$emit('update:broadcastingChannels', { ...broadcastingChannels, web: Boolean($event.target.checked) })"
        :disabled="disabled">
      <label class="form-check-label">
        Web
       </label>
    </div>
    <div class="form-check" @click.stop="changeOptionValue('youtube')">
      <input type="checkbox"
        class="form-check-input"
        :checked="broadcastingChannels.youtube"
        @input="$emit('update:broadcastingChannels', { ...broadcastingChannels, youtube: Boolean($event.target.checked) })"
        :disabled="disabled">
      <label class="form-check-label">
        Youtube
      </label>
    </div>
    <div class="form-check" @click.stop="changeOptionValue('facebook')">
      <input type="checkbox"
        class="form-check-input"
        :checked="broadcastingChannels.facebook"
        @input="$emit('update:broadcastingChannels', { ...broadcastingChannels, facebook: Boolean($event.target.checked) })"
        :disabled="disabled">
      <label class="form-check-label">
        Facebook
      </label>
    </div>
    <div class="form-check" @click.stop="changeOptionValue('twitter')">
      <input type="checkbox"
        class="form-check-input"
        :checked="broadcastingChannels.twitter"
        @input="$emit('update:broadcastingChannels', { ...broadcastingChannels, twitter: Boolean($event.target.checked) })"
        :disabled="disabled">
      <label class="form-check-label">
        Twitter
      </label>
    </div>
  </FormGroup>
</template>

<script>
import _ from 'lodash';
import FormGroup from '@/components/FormGroup.vue';

export default {
  props: {
    broadcastingChannels: {
      type: Object,
      default: () => {},
    },
    updateBroadcastingStateError: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    FormGroup,
  },
  methods: {
    changeOptionValue(keyName) {
      if (!this.disabled) {
        const value = _.get(this.broadcastingChannels, keyName, null);
        _.set(this.broadcastingChannels, keyName, !value);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';

.form-check-label {
  cursor: pointer;
}

.form-check {
  margin-bottom: $spacer * 0.35;
}


.form-group-container {
  display: flex;

  .form-group-item {
    margin-right: $spacer * 2;

    &:last-child {
      margin-right: 0;
    }
  }
}
</style>
